"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPointerPosOnCanvas = void 0;
/**
 * @description
 * マウスポインタの画像上の位置をキャンバス上の位置に変換する．
 */
var toPointerPosOnCanvas = function (imgRect) {
    // dummy comment to control prettier
    return function (pointerPos) {
        return pointerPos.withMutations(function (from) {
            return from.update('x', function (x) { return x + imgRect.left; }).update('y', function (y) { return y + imgRect.top; });
        });
    };
};
exports.toPointerPosOnCanvas = toPointerPosOnCanvas;
